import { Component, OnInit } from '@angular/core';

@Component({
    moduleId: module.id,
    selector: 'fixedplugin-cmp',
    templateUrl: 'fixedplugin.component.html',
    styleUrls:['fixedplugin.component.css']
})

export class FixedPluginComponent implements OnInit{

  public sidebarColor: string = "grey";
  public sidebarActiveColor: string = "info";

  public state: boolean = true;

  changeSidebarColor(color){
    var sidebar = <HTMLElement>document.querySelector('.sidebar');
    

    this.sidebarColor = color;
    if(sidebar != undefined){
        sidebar.setAttribute('data-color',color);
    }
  }
  changeSidebarActiveColor(color){
    var sidebar = <HTMLElement>document.querySelector('.sidebar');
    var btnPrimary = <HTMLElement>document.querySelector('.btn-primary');
    btnPrimary.style.setProperty('--my-color', color);
    this.sidebarActiveColor = color;
    if(sidebar != undefined){
        sidebar.setAttribute('data-active-color',color);
    }
  }
  ngOnInit(){}
}
